/*
 * @Author: yuzhuo.zhou
 * @Date: 2020-04-29 09:15:30
 * @Last Modified by: yuzhou.zhou
 * @Last Modified time: 2020-06-16 11:18:24
 */

<script>
//http://10.9.66.11/portal/ui/redirect/https%3a%2f%2fwww.baidu.com
import ApiConfig from 'api/config'
export default {
  name:'redirectTop',
  created(){
    let redirect = location.href.split('url=')[1];
    if(redirect && redirect.includes('http')){
      if(redirect.includes('%')) redirect = decodeURIComponent(redirect)
      top.window.location.href = redirect
    }else {
      top.window.location.href = `${ApiConfig.context}/login`
    }
  },
  render(h){
    return h('div')
  }
}
</script>

